import React from 'react';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Text from 'components/Text';

import { toI18n } from 'util/i18n';

const ScrimGeneralModal = ({ i18nPrefix, onRequestClose }) => {
  const secondText = toI18n(`${i18nPrefix}.text2`);
  return (
    <Box hcenter column maxw={566}>
      <Box tcenter mb={48}>
        <Text white fw600 fs={38} i18n={`${i18nPrefix}.header`} />
      </Box>

      <Box tcenter mb={secondText ? 48 : 56}>
        <Text white fw600 fs24 i18n={`${i18nPrefix}.text`} />
      </Box>

      {secondText && (
        <Box tcenter mb={56}>
          <Text white fw600 fs24>
            {secondText}
          </Text>
        </Box>
      )}

      <Box w={236}>
        <Button
          fullWidth
          theme="primary"
          onClick={onRequestClose}
          i18n={`${i18nPrefix}.button`}
          size="large"
        />
      </Box>
    </Box>
  );
};

export default ScrimGeneralModal;
